import { Link } from 'react-router-dom';
import { useSiteSettings } from '../services/siteSettingsService';

const Footer = () => {
  const { settings } = useSiteSettings();
  const socialLinks = [
    { label: 'Facebook', href: settings.facebookUrl },
    { label: 'Instagram', href: settings.instagramUrl },
    { label: 'LinkedIn', href: settings.linkedinUrl },
  ].filter((item) => item.href.trim());

  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <div className="text-2xl font-bold text-neon-orange mb-4">
              {settings.brandShortName}
            </div>
            <p className="text-gray-600 mb-4">{settings.footerDescription}</p>
            <div className="space-y-2">
              <p className="text-gray-600">{settings.footerCopyright}</p>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Suivez-nous</h3>
            <div className="space-y-2">
              {socialLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  className="block text-gray-600 hover:text-neon-orange"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Liens rapides</h3>
            <div className="space-y-2">
              <Link to="/services" className="block text-gray-600 hover:text-neon-orange">
                Services
              </Link>
              <Link to="/activites" className="block text-gray-600 hover:text-neon-orange">
                Activités
              </Link>
              <Link to="/faq" className="block text-gray-600 hover:text-neon-orange">
                FAQ
              </Link>
              <Link to="/contact" className="block text-gray-600 hover:text-neon-orange">
                Contact
              </Link>
            </div>
          </div>


          <div>
            <h3 className="text-lg font-semibold mb-4">Informations</h3>
            <div className="space-y-2">
              <Link to="/mentions-legales" className="block text-gray-600 hover:text-neon-orange">
                Mentions légales
              </Link>
              <Link to="/conditions-generales" className="block text-gray-600 hover:text-neon-orange">
                Conditions générales
              </Link>
              <Link to="/moyens-de-paiement" className="block text-gray-600 hover:text-neon-orange">
                Moyens de paiement
              </Link>
              <Link to="/klarna-info" className="block text-gray-600 hover:text-neon-orange">
                Qu'est-ce que Klarna ?
              </Link>
              
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
